import React, { useEffect, useState } from 'react'

import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { addDays } from 'date-fns'

import { Checkbox } from '@components/Checkbox'
import { SheetModal } from '@components/SheetModal'
import { SheetModalHandle } from '@components/SheetModalHandle'
import { useSharedDates } from '@contexts/sharedDates'
import { useDate } from '@hooks/dates'
import { useBulkEditTasks } from '@hooks/tasks/bulkEdit'
import { IGenericTask } from '@interfaces/task/generic/IGenericTask'

import { Container, ListLabel, SelectionContainer } from '../styles'

interface IProps {
  tasks: IGenericTask[]
  openModal: boolean
  onClose: () => void
  onSave?: () => void
}

export function ChangeStartTimeModal({
  tasks,
  openModal,
  onClose,
  onSave,
}: IProps) {
  const { taskId } = useParams()
  const location = useLocation()
  const currentRoute = location.pathname

  const { getSiteStartTime, getWeekRange } = useDate()
  const { selectedDate } = useSharedDates()

  const handle = () => (
    <SheetModalHandle
      showButtons
      isCancelEnabled
      onCancelButton={onClose}
      isSaveEnabled={!!selectedDay}
      onSaveButton={() => selectedDay && handleUpdateStartTime()}
    >
      Move to
    </SheetModalHandle>
  )
  const { weekStart } = getWeekRange(selectedDate)
  const [selectedDay, setSelectedDay] = useState('')

  const { mutateAsync: putTasks } = useBulkEditTasks()

  const week = [
    { dayString: 'To do', dayDate: getSiteStartTime(5, weekStart) },
    { dayString: 'Monday', dayDate: getDatesOfTheWeek(0) },
    { dayString: 'Tuesday', dayDate: getDatesOfTheWeek(1) },
    { dayString: 'Wednesday', dayDate: getDatesOfTheWeek(2) },
    { dayString: 'Thursday', dayDate: getDatesOfTheWeek(3) },
    { dayString: 'Friday', dayDate: getDatesOfTheWeek(4) },
    { dayString: 'Saturday', dayDate: getDatesOfTheWeek(5) },
    { dayString: 'Sunday', dayDate: getDatesOfTheWeek(6) },
  ]

  useEffect(() => {
    setSelectedDay('')
  }, [openModal])

  const weekDays =
    !currentRoute.includes('todo')
      ? week
      : week.filter((weekDay) => weekDay.dayString !== 'To do')

  function handleUpdateStartTime() {
    const weekDay = weekDays.find(({ dayString }) => dayString === selectedDay)
    const startTime = weekDay?.dayDate
    const taskIds = tasks.map((task) => task.id)

    putTasks({
      ids: taskIds,
      changes: { startTime },
      urlSuffix: 'planningTaskStatus',
    })

    reset()
  }

  function reset() {
    onClose()
    onSave && onSave()
  }

  function getDatesOfTheWeek(dayNumber: number) {
    return addDays(weekStart, dayNumber)
  }

  return (
    <SheetModal
      initialSnap={2}
      open={openModal}
      handle={handle}
      onClose={onClose}
    >
      <Container>
        {weekDays.map((item) => (
            <SelectionContainer key={item.dayString} onClick={() => setSelectedDay(item.dayString)}>
              <ListLabel>{item.dayString}</ListLabel>
              <Checkbox isChecked={selectedDay === item.dayString} />
            </SelectionContainer>
        ))}
      </Container>
    </SheetModal>
  )
}
